import React from 'react'
import styled from 'styled-components';
import { Button } from 'react-bootstrap';
import CarouselBar from '../components/CarouselBar';
import '../style/custom.css';
import { useTranslation } from 'react-i18next';

const Styles = styled.div` 
.content-main h3 {
  color:#a6192e;
}

.content { 
  padding-bottom: 3em;
}

`;
 

const Home = () => {  
  const { t } = useTranslation(); // LANGUAGE

  return (
    <Styles>
      <CarouselBar />
      <div className="contianer">
        <br />
        <div className="content container">
          <div className="row content-main justify-content-center">
            <center>
              <h3 className="animate__animated animate__fadeInDown animate__delay-500ms">
                {/* Please Select Visitor Type */}
                {t('mainpage-heading.1')}
              </h3>
            </center>
          </div>
          <br />
          <div className="container">
            <div className="row justify-content-center">
              <Button
                className="btn btn-primary btn-lg btn-block col-md-7 col-12 animate__animated animate__fadeInLeft animate__delay-600ms" href="/WardVisitor">
                {/* Ward Visitor */}
                {t('mainpage-btn.1')}
              </Button>

              <Button
                className="btn btn-primary btn-lg btn-block col-md-7 col-12 animate__animated animate__fadeInRight animate__delay-700ms" href="/OutpatientVisitor">
                {/* Accompanying Outpatient */}
                {t('mainpage-btn.2')}
              </Button>

              <Button
                className="btn btn-primary btn-lg btn-block col-md-7 col-12 animate__animated animate__fadeInLeft animate__delay-800ms" href="/DayVisitor">
                {/* Accompanying Day Procedure Patient */}
                {t('mainpage-btn.3')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Styles >
  );
}

export default Home;